import Axios from 'axios';
import { BaseSocket, CONNECTION_STATE } from '~/web-frontend-core/api/connector/socketListener/socket/BaseSocket';
import { CHANNEL_ACTION } from '~/web-frontend-core/api/const/base';
import { ONE_SECOND_MS } from '~/web-frontend-core/utils/time';
import { SubscriptionsStore } from '~/web-frontend-core/utils/SubscriptionsStore';
import { DATA_TYPE_CODE } from '../../../const/base';
const getQueryStringForArray = (paramName, array) => {
    return array.reduce((prev, curr, index, array) => {
        const isLast = index === array.length - 1;
        return `${prev}${paramName}=${curr}` + (!isLast ? '&' : '');
    }, '');
};
// Backend requires array to be passed as ?odds=2620840482&odds=2620840840
// instead of ?odds[]=2620840482&odds[]=2620840840
const getCustomRequestParts = (params) => {
    const newParams = {};
    let queryString = '';
    for (let i = 0; i < Object.keys(params).length; i++) {
        const param = Object.keys(params)[i];
        const value = params[param];
        if (Array.isArray(value)) {
            queryString += getQueryStringForArray(param, value);
        }
        else {
            newParams[param] = value;
        }
    }
    queryString = queryString.length ? `?${queryString}` : '';
    return {
        queryString,
        newParams
    };
};
export const subscriptions = new SubscriptionsStore();
const matchesSubscriptionTypes = [
    // Live-матчи с видео
    DATA_TYPE_CODE.LIVE_MATCHES_WITH_VIDEO_MOBILE,
    DATA_TYPE_CODE.LIVE_MATCHES_WITH_VIDEO,
    // Live-матчи из избранного
    DATA_TYPE_CODE.LIVE_MATCHES_FAVORITES_MOBILE,
    DATA_TYPE_CODE.LIVE_MATCHES_FAVORITES,
    // Топ Live-матчи
    DATA_TYPE_CODE.LIVE_MATCHES_BY_TOP_MOBILE,
    DATA_TYPE_CODE.LIVE_MATCHES_BY_TOP,
    // Live-матчи по чемпионату (для сайта)
    DATA_TYPE_CODE.LIVE_MATCHES_BY_CHAMPIONSHIP,
    // Live-матчи по спорту
    DATA_TYPE_CODE.LIVE_MATCHES_BY_SPORT_MOBILE,
    DATA_TYPE_CODE.LIVE_MATCHES_BY_SPORT,
    // Все Live-матчи для сайта
    DATA_TYPE_CODE.LIVE_MATCHES_ALL,
];
const handleMatchesTypes = (t) => {
    if (!matchesSubscriptionTypes.includes(t))
        return;
    matchesSubscriptionTypes.forEach(t => {
        subscriptions.remove(t);
    });
};
/**
 * @name AxiosSocket
 * @class
 * @implements {ISocket}
 * Реализует интерфейс веб-сокета по протоколу xhr
 */
export class AxiosSocket extends BaseSocket {
    constructor(url) {
        super();
        this.url = url;
        this.state = CONNECTION_STATE.OPEN;
    }
    get readyState() {
        return this.state;
    }
    loop() {
        if (this.updateIntervalID) {
            return;
        }
        this.updateIntervalID = window.setInterval(() => {
            subscriptions
                .getAll()
                .forEach((message) => this.handleMessage(message));
        }, ONE_SECOND_MS);
    }
    handleMessage(params) {
        // it should not send d as params if d is not an object (e.g. params.d is a string with jwt)
        let requestParamsObj = {};
        let query = '';
        if (typeof params.d === 'object') {
            const { queryString, newParams } = getCustomRequestParts(params.d);
            requestParamsObj = {
                params: newParams
            };
            query = queryString;
        }
        Axios
            .get(`${this.url}${params.t}${query}`, Object.assign({}, requestParamsObj))
            .then((r) => {
            this.state = CONNECTION_STATE.OPEN;
            if (r.statusText !== 'OK') {
                throw new Error(String(r.data));
            }
            this.onmessage && this.onmessage(new MessageEvent('message', { data: JSON.stringify(r.data) }));
        }).catch((e) => {
            // subscriptions.remove(params.t)
            // this.close();
            throw e;
        }).catch(this.onerror);
    }
    send(s, target) {
        const params = JSON.parse(s);
        this.state = CONNECTION_STATE.OPEN;
        if (params.op === CHANNEL_ACTION.SUBSCRIBE) {
            handleMatchesTypes(params.t);
            subscriptions.upsert(params);
        }
        if (!target && params.op === CHANNEL_ACTION.UNSUBSCRIBE) {
            subscriptions.remove(params.t);
        }
        this.loop();
    }
    dispatchEvent(e) {
        this.close();
        this.onerror(e);
    }
    close() {
        this.state = CONNECTION_STATE.CLOSED;
        clearInterval(this.updateIntervalID);
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/api/connector/socketListener/socket/Axios.js